import {useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {selectAccessToken} from '@components/Login/userSlice';
import permissionsService from '@utils/permissionsService';

export function useIsDashboardLinkVisible() {
    const location = useLocation();
    const accessToken = useSelector(selectAccessToken);

    const isRecipientPath = location.pathname.includes('/recipient');
    const isScopedUser = permissionsService.getIsScopedUser({accessToken});

    return !isRecipientPath && !isScopedUser;
}
